import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/ru';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.locale('ru');
dayjs.extend(relativeTime);

export const DATE_TIME_SECONDS = 'YYYY-MM-DD HH:mm:ss';
export const DATE_TIME_MINUTE = 'YYYY-MM-DD HH:mm';
export const DATE_YEAR = 'DD.MM.YYYY';

export const format =
    (timestamp_unix: number) =>
    (pattern: string): string => {
        return dayjs.unix(timestamp_unix).format(pattern);
    };

export const formatExtended = (time: Dayjs) => {
    return dayjs(time).format(DATE_YEAR);
};

export const formatWithTime = (time: Dayjs) => {
    return dayjs(time).format(DATE_TIME_SECONDS);
};

export const formatLeftTime = (time: number) => {
    return dayjs.unix(time).toNow(true);
};
